/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Tags_LabelInputs */

const en_style_guide_manager_tags_label = /** @type {(inputs: Style_Guide_Manager_Tags_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags`)
};

const fr_style_guide_manager_tags_label = /** @type {(inputs: Style_Guide_Manager_Tags_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags`)
};

const de_style_guide_manager_tags_label = /** @type {(inputs: Style_Guide_Manager_Tags_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags`)
};

const it_style_guide_manager_tags_label = /** @type {(inputs: Style_Guide_Manager_Tags_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etichette`)
};

const ru_style_guide_manager_tags_label = /** @type {(inputs: Style_Guide_Manager_Tags_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Теги`)
};

const es_style_guide_manager_tags_label = /** @type {(inputs: Style_Guide_Manager_Tags_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etiquetas`)
};

const zh_cn2_style_guide_manager_tags_label = /** @type {(inputs: Style_Guide_Manager_Tags_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标签`)
};

const ja_style_guide_manager_tags_label = /** @type {(inputs: Style_Guide_Manager_Tags_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タグ`)
};

const hi_style_guide_manager_tags_label = /** @type {(inputs: Style_Guide_Manager_Tags_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टैग`)
};

const pt_pt2_style_guide_manager_tags_label = /** @type {(inputs: Style_Guide_Manager_Tags_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etiquetas`)
};

/**
* | output |
* | --- |
* | "Tags" |
*
* @param {Style_Guide_Manager_Tags_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_tags_label = /** @type {((inputs?: Style_Guide_Manager_Tags_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Tags_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_tags_label(inputs)
	if (locale === "de") return de_style_guide_manager_tags_label(inputs)
	if (locale === "it") return it_style_guide_manager_tags_label(inputs)
	if (locale === "ru") return ru_style_guide_manager_tags_label(inputs)
	if (locale === "es") return es_style_guide_manager_tags_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_tags_label(inputs)
	if (locale === "ja") return ja_style_guide_manager_tags_label(inputs)
	if (locale === "hi") return hi_style_guide_manager_tags_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_tags_label(inputs)
	return en_style_guide_manager_tags_label(inputs)
});